var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.carts.length != 0 ? _c('page-section', {
    staticClass: "page-section--xs pb-0",
    scopedSlots: _vm._u([{
      key: "containerImmersive",
      fn: function () {
        return _vm._l(_vm.carts, function (cart, index) {
          return _c('div', {
            key: index,
            class: {
              'mt-4px mt-md-8px': index != 0
            }
          }, [_c('shop-product-carts-item', {
            on: {
              "input": _vm.emit,
              "pull": function ($event) {
                return _vm.pull(index);
              }
            },
            model: {
              value: _vm.carts[index],
              callback: function ($$v) {
                _vm.$set(_vm.carts, index, $$v);
              },
              expression: "carts[index]"
            }
          })], 1);
        });
      },
      proxy: true
    }], null, false, 2329673478)
  }) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }